var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96.3415,
    height: 100,
    rx: 8,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.418 76.427L24.6375 53.988C25.1795 52.904 25.9524 52.0368 26.9562 51.3864C27.96 50.736 29.0841 50.4108 30.3285 50.4108C31.6294 50.4108 32.8218 50.749 33.9058 51.4254C34.9898 52.1018 35.7757 53.0644 36.2635 54.3132L38.4586 59.6791C38.567 60.0043 38.8109 60.1528 39.1903 60.1246C39.5697 60.0964 39.8136 59.9208 39.922 59.5978L46.9139 36.2644C47.6727 33.6628 49.1231 31.5761 51.2651 30.0043C53.4071 28.4325 55.8321 27.6466 58.5399 27.6466C61.1958 27.6466 63.5676 28.4184 65.6554 29.962C67.7432 31.5056 69.1925 33.5252 70.0033 36.0205L84.0684 76.427H13.418ZM29.1903 43.9067C26.4803 43.9067 24.1768 42.9441 22.2798 41.0189C20.3827 39.0937 19.4342 36.8043 19.4342 34.1506C19.4342 31.4406 20.3827 29.1371 22.2798 27.2401C24.1768 25.343 26.4803 24.3945 29.1903 24.3945C31.9004 24.3945 34.2039 25.343 36.1009 27.2401C37.9979 29.1371 38.9464 31.4406 38.9464 34.1506C38.9464 36.8065 37.9979 39.097 36.1009 41.0222C34.2039 42.9474 31.9004 43.9089 29.1903 43.9067Z",
    fill: "#424040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGallery);
export default __webpack_public_path__ + "static/media/emptyGallery.699073750104aaec3200cb404e3220fd.svg";
export { ForwardRef as ReactComponent };